import {
  useQuery,
  hashQueryKey,
  QueryClient,
  QueryClientProvider as QueryClientProviderBase,
} from "react-query";
import {
  getFirestore,
  connectFirestoreEmulator,
  onSnapshot,
  doc,
  collection,
  query,
  where,
  orderBy,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  addDoc,
  deleteDoc,
  limit,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { db, client, createQuery, format } from "../providers/database";

export function updateAutoSave(collection: string, id: string, data: any) {
  console.log(id, data)
  return updateDoc(doc(db, collection, id), { ...data, latestUpdate: Timestamp.now() });
}

export async function updateAutoSaveForResume(collection: string, id: string, data: any) {

  const docRef = doc(db, collection, id);

  try {
    // Attempt to update the document
    await updateDoc(docRef, { ...data, latestUpdate: Timestamp.now() });

  } catch (error: any) {
    if (error.code === "not-found") {

      // Document does not exist, create a new one
      await setDoc(docRef, { ...data, latestUpdate: Timestamp.now() });

    } else {
      // Handle other errors
      console.error("Error updating document:", error);
    }
  }
}

export function updateAddress(collection: string, id: string, data: any) {
  return updateDoc(doc(db, collection, id), { address: { state: data }, latestUpdate: Timestamp.now() });
}

export const setAutoSave = (collection: string, id: string, data: object) => {
  console.log("utility.ts, setAutoSave, data: ", data);
  return setDoc(doc(db, collection, id), data);
};

export async function updateStatusHistory(
  parent: string,
  id: string,
  data: object,
) {
  await addDoc(collection(db, `${parent}/${id}/StatusHistory`), data);
}

export async function updateRenewHistory(
  parent: string,
  id: string,
  data: object,
) {
  await addDoc(collection(db, `${parent}/${id}/RenewHistory`), data);
}

// This function logs the activity and writes it to the "Activity" collection
export const logActivity = async (
  collectionName: string,
  id: string,
  activityField: string,
  beforeField: string,
  afterField: string,
  who: string,
  activityLabel: string,
) => {
  const params = {
    collection: collectionName,
    id,
    activityField,
    beforeField,
    afterField,
    created_at: Timestamp.now().toDate(),
    who,
    activityLabel,
  };
  await addDoc(collection(db, "Activity"), params);
};

export const analyticsLog = async (
  type: string,
  typeId: string,
  userId: string,
  route: string,
) => {
  const params = {
    type: type,
    typeId: typeId,
    userId: userId,
    route: route,
    createdAt: Timestamp.now(),
  };
  await addDoc(collection(db, "Views"), params);
};

export function useUtilitySearch(
  collectionName: string,
  name: string,
  field: string,
  status: string,
  id: string,
) {
  return useQuery(
    [name, query],
    createQuery(() =>
      query(
        collection(db, collectionName),
        where(field, "==", id),
        where("status", "==", status),
      ),
    ),
    { enabled: !!query },
  );
}


export const AffiliationLabels = {
  "affiliation_FM": {
    "code": "FM",
    "description": null,
    "group": "affiliation",
    "icon": null,
    "isActive": true,
    "label": "Military Family Member",
    "sortOrder": 20
  },
  "affiliation_R": {
    "code": "R",
    "description": null,
    "group": "affiliation",
    "icon": null,
    "isActive": true,
    "label": "Retired",
    "sortOrder": 40
  },
  "affiliation_S": {
    "code": "S",
    "description": null,
    "group": "affiliation",
    "icon": null,
    "isActive": true,
    "label": "Military Spouse",
    "sortOrder": 30
  },
  "affiliation_V": {
    "code": "V",
    "description": null,
    "group": "affiliation",
    "icon": null,
    "isActive": true,
    "label": "Veteran",
    "sortOrder": 50
  }
}